import { OuiSelectOption } from 'omnium-ui/form-field';
import { Observable } from 'rxjs';
import { inNotInOperator, fullComparator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getActifsBuilders(optionsActifFiltrePatrimoine$: Observable<OuiSelectOption<string>[]>): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'ACTIFS',
      'PATRIMOINE_ACTIF_TYPE',
      'investisseurPatrimoines.some.patrimoine.patrimoineActif.type',
      inNotInOperator,
      'SelectMultiple',
      optionsActifFiltrePatrimoine$
    ),
    new ItemFiltreCustomBuilder(
      'ACTIFS',
      'PATRIMOINE_ACTIFS_TOTAL_VALEUR',
      'bilanFinancier.effectiveActif',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
  ];
}
